import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbGoogledrive: BowlBlock = withIntegration(options.slug.llmKbGoogledrive, [
  {
    name: 'serviceAccountKey',
    type: 'json',
    required: true,
  },
  {
    name: 'driveId',
    type: 'withText',
    required: true,
  },
  {
    name: 'recursive',
    type: 'checkbox',
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
  },
]);
